import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import Avatar from '../avatar/avatar';
import Icon from '../icon/icon';
import { CollapsableSize } from '../types/ui-kit.types';

interface CollapsableMessageI {
    id: string;
    name: string;
    date: string;
    message: string;
    size: CollapsableSize;
    isEditing: boolean;
    editDisabled: boolean;
    deleteDisabled: boolean;
    onEdit?(id: string, message: string): void;
    onDelete?(id: string): void;
}

const CollapsableMessage: FC<CollapsableMessageI> = ({
    id,
    name,
    date,
    message,
    size,
    isEditing,
    editDisabled,
    deleteDisabled,
    onEdit,
    onDelete,
}) => {
    return (
        <div key={id} className="flex space-x-2 ">
            <Avatar name={name} />
            <div className="flex flex-col bg-primary-50 px-3 py-1.5 rounded-xl text-sm">
                <div className={twMerge('flex items-center space-x-1', size === 'compact' && 'justify-between')}>
                    <span
                        className={twMerge(
                            'font-semibold font-poppins',
                            size === 'compact' && 'line-clamp-1 max-w-[180px]',
                        )}
                    >
                        {name}
                    </span>
                    <span className={twMerge('text-surface-disabled !mr-3', size && 'text-[12px]')}>{date}</span>
                    {size === 'large' && (
                        <>
                            {onEdit && (
                                <button
                                    className={`w-4 ${isEditing && 'invisible'}`}
                                    onClick={() => onEdit(id, message)}
                                    disabled={editDisabled}
                                >
                                    <Icon name="ri-pencil-fill" size={16} className="text-surface-disabled" />
                                </button>
                            )}
                            {onDelete && (
                                <button
                                    className={twMerge(
                                        'w4',
                                        isEditing && 'invisible',
                                        deleteDisabled && 'animate-spin',
                                    )}
                                    onClick={() => onDelete(id)}
                                    disabled={deleteDisabled}
                                >
                                    <Icon
                                        name={deleteDisabled ? 'ri-loader-4-line' : 'ri-delete-bin-7-fill'}
                                        size={16}
                                        className="text-surface-disabled"
                                    />
                                </button>
                            )}
                        </>
                    )}
                </div>
                <span>{message}</span>
            </div>
        </div>
    );
};

export default CollapsableMessage;
